//////////////////////////////////////////////////////////////////////////////////////   IMPORT
///////////////////////////////////////////////////////////   REACT
import React from 'react';
///////////////////////////////////////////////////////////   LIBS
import Button from 'react-bootstrap/Button';
import { decode } from 'html-entities';
///////////////////////////////////////////////////////////   SCSS
import './framelist.styles.scss';

//////////////////////////////////////////////////////////////////////////////////////    CLASS SETUP
class FrameList extends React.Component<any, { [key: string]: any }> {
  constructor(props: any) {
    super(props);
    this.state = {
      frameList: this.props.frameList,
      renturnList: null,
      activeFrame: null
    };
  }
  ///////////////////////////////////////////////////////////   CLASS METHODS
  /**
   * Handle frame click
   * Handles if user click on frame buttons below video
   * @param clickedItemId
   */
  private handleFrameClick = (clickedItemId: number): void => {
    this.setState({ activeFrame: clickedItemId });
    this.props.handleFrames(clickedItemId);
  };
  componentDidUpdate(prevProps: any) {
    if (this.props.frameList !== prevProps.frameList) {
      this.setState({ frameList: this.props.frameList });
    }
  }
  ///////////////////////////////////////////////////////////   RENDER
  render() {
    const { frameList } = this.state;
    return frameList.map((i: any, k: number) => (
      <Button key={'frameList_' + k} className={'rounded-0'} variant='secondary' onClick={() => this.handleFrameClick(i.frame)}>
        <span className='player-arrow-icons'>{decode(i.char)}</span>
      </Button>
    ));
  }
}

export default FrameList;
